<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc('role', 1) }} {{ $t('access') }}</div>
        <div class="section-subTitle my-2">{{ $t('roleaccess_dash_msg') }}</div>
      </div>
      <div>
        <b-button variant="default" to="add-role-access" class="btn-blue">{{ $tc('add') }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex">
        <b-dropdown text="Name" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#" v-for="(loop , key) in 10" :key="key">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="No of Employees" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here asdasdasdasdas</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Stauts" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>

        <b-dropdown text="Last Updated" variant="default" class="mr-3">
          <b-dropdown-item href="#">Action</b-dropdown-item>
          <b-dropdown-item href="#">Another action</b-dropdown-item>
          <b-dropdown-item href="#">Something else here</b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="d-flex align-items-center">
        <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>
        <button
          class="btnj btn-gridView mr-3"
           v-if = GridViewFlag
          :class="gridView ? 'active':''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
           v-if = GridViewFlag
          :class="listView ? 'active':''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>{{ $tc('role', 1) }} {{ $t('access') }}</th>
          <th>{{ $tc('feature', 1) }} {{ $t('name') }}</th>
          <th class="text-right">
            <span class="pr-5">{{ $tc('status', 2)}}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(role , roleKey) in RoleFeaures" :key="roleKey">
          <td>{{ role.role_name }}</td>
          <td>{{ role.feature_name }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" disabled />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  :to="{path :'edit-role-access',query: {role_featuresId:role.rf_id}}"
                >
                  <span class="edit-pen"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{path :'view-role-access',query: {role_featuresId:role.rf_id}}"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(role , roleKey) in RoleFeaures"
        :key="roleKey"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $t('admin') }}</h6>
            <div>
              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  :to="{path :'edit-role-access',query: {role_featuresId:role.rf_id}}"
                >
                  <span class="edit-pen"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{path :'view-role-access',query: {role_featuresId:role.rf_id}}"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">059</div>
              <div class="text">
                No of
                <br />employees
              </div>
            </div>
            <div class="d-flex align-items-end">
              <label class="ios-switch">
                <input type="checkbox" class="ios-checkbox" />
                <span class="switch-slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 

<script>
import UserPermission from "@/services/UserPermission";
import { uniqBy } from "lodash";
export default {
  data() {
    return {
      gridView: false,
      listView: true,
      RoleFeaures: []
    };
  },
  mounted() {
    this.getAllRoles();
  },
  methods: {
    getAllRoles: function() {
      UserPermission.ReadAllRoles()
        .then(response => {
          const { data } = response;
          if (data.length > 0) {
            this.RoleFeaures = data;
            // this.RoleFeaures = uniqBy(this.RoleFeaures, "role_name");
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    /* eslint-disable */

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
    // onClickEdit: function(){
    //   this.$router.push({ path: 'master/editaggregators' })
    // }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/RoleManagementContainer/RoleAccessComponents/roleAccess.vue